const stringifyResponse = response => {
    if (response === undefined || response === null || response === '') {
        return '';
    }

    try {
        return JSON.stringify(response, null, 2) || '';
    } catch (e) {
        return '';
    }
};

const appendStatusLabel = ({field, label, error = false}) => {
    const labelElement = document.createElement('label');

    if (error) {
        const errorText = document.createElement('span');
        errorText.className = 'ui error text';
        errorText.appendChild(document.createTextNode(label));
        labelElement.appendChild(errorText);
    } else {
        labelElement.appendChild(document.createTextNode(label));
    }

    field.appendChild(labelElement);
};

const appendFallbackResponse = ({field, response}) => {
    const pre = document.createElement('pre');
    pre.className = 'ui container scrolling very short';

    const code = document.createElement('code');
    code.appendChild(document.createTextNode(stringifyResponse(response)));

    pre.appendChild(code);
    field.appendChild(pre);

    return pre;
};

const insertAfter = ({field, afterElement}) => {
    if (afterElement) {
        afterElement.insertAdjacentElement('afterend', field);
    }
};

const mountResponseEditor = ({field, response, codeEditorModule, afterElement}) => {
    codeEditorModule.codeEditor({
        callbackFn: editor => {
            editor.setValue(stringifyResponse(response));
            field.appendChild(editor.getWrapperElement());
            insertAfter({field, afterElement});
            editor.refresh();
        },
        errorFn: () => {
            appendFallbackResponse({field, response});
            insertAfter({field, afterElement});
        },
        options: {
            mode: 'application/json',
            readOnly: true,
            foldGutter: true,
            lineWrapping: true,
            gutters: ['CodeMirror-lint-markers', 'CodeMirror-foldgutter'],
        },
    });
};

const createTestResponseField = ({id, label, error = false, response, codeEditorModule, afterElement}) => {
    const field = document.createElement('div');
    field.id = id;
    field.className = 'field';

    appendStatusLabel({field, label, error});

    if (codeEditorModule) {
        mountResponseEditor({field, response, codeEditorModule, afterElement});
    } else {
        appendFallbackResponse({field, response});
        insertAfter({field, afterElement});
    }

    return field;
};

export {
    appendFallbackResponse,
    createTestResponseField,
    stringifyResponse
};
